/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */

import config from "@/config";
import axios from "axios";
import store from "@/store";

export default {
	getLiveState() {
		return axios.get(`${config.PORTAL_PROXY_URL}/api/v1/proxy/astrum/live/state`, {
			headers: {
				"Authorization": store.state.accessToken
			}
		});
	},

	getAstrumPlayers({accountId, stationId}) {
		return axios.get(
			`${config.PORTAL_PROXY_URL}/api/v1/proxy/astrum/accounts/${accountId}/stations/${stationId}/players`,
			{
				params: {filter: stationId},
				headers: {
					"Authorization": store.state.accessToken
				}
			}
		);
	},

	getAstrumPlayerToken(accountId, stationId, playerKey) {
		return axios.get(
			`${config.PORTAL_PROXY_URL}/api/v1/proxy/astrum/accounts/${accountId}/stations/${stationId}/players/${playerKey}/token`,
			{
				headers: {
					"Authorization": store.state.accessToken
				}
			}
		);
	},

	getAstrumPlayerGuestToken(accountId, stationId, playerKey, payload) {
		return axios.post(
			`${config.PORTAL_PROXY_URL}/api/v1/proxy/astrum/accounts/${accountId}/stations/${stationId}/players/${playerKey}/guest_token`,
			payload,
			{
				headers: {
					"Authorization": store.state.accessToken
				}
			}
		);
	},

	createTempLivePlayer(accountID, stationID, payload) {
		return axios.post(
			`${config.PORTAL_PROXY_URL}/api/v1/proxy/astrum/accounts/${accountID}/stations/${stationID}/players`,
			payload,
			{
				headers: {
					"Authorization": store.getters.getAccessToken()
				}
			}
		);
	}
}
